import axios from "axios";

const API_URL =
"https://vortexnetowrknew.co.uk/php-backend/profile.php";

export async function getProfile(username) {
const response = await axios.get(API_URL, {
params: {
username,
},
});

return response.data;
}
